import { tm } from '@captaincause/ui/tm'
import { flattenImage } from 'utils/strapi/image'
import { StrapiImage } from 'components/StapiImage'
import type { StrapiApiImage } from 'types/strapi/image'

export interface PostMediaProps {
  media: StrapiApiImage | null
  caption: string | null
}

export default function PostMedia({
  media: propsMedia,
  caption,
}: PostMediaProps) {
  if (!propsMedia) return null

  const media = flattenImage(propsMedia)

  if (!media) return null

  const type = media?.mime?.split('/')[0]

  if (type === 'image') {
    return (
      <figure className="mb-10">
        <StrapiImage
          {...media}
          className={tm(
            'mx-auto max-w-[100%] rounded-lg',
            media.width > (media?.height ?? 0)
              ? 'h-auto'
              : 'max-h-[1000px] w-auto',
          )}
          quality={100}
        />
        {caption ? (
          <figcaption className="mt-2 w-full text-center text-dark-gray">
            {caption}
          </figcaption>
        ) : null}
      </figure>
    )
  }

  if (type === 'video') {
    const finalUrl =
      media.provider === 'local'
        ? `${process.env.NEXT_PUBLIC_STRAPI_MEDIA_API_URL}${media.url}`
        : media.url

    return (
      /* eslint-disable-next-line jsx-a11y/media-has-caption */
      <div className="mb-10">
        <video
          className="mx-auto h-[160px] max-w-[100%] rounded-lg md:mx-auto md:h-[200px]"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={finalUrl} type={media.mime} />
        </video>
      </div>
    )
  }

  return null
}
